// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2B3kP","avatar":"style_avatar__3s7RH","menuIcon":"style_menuIcon__q2-BF"};